module.exports = __webpack_public_path__ + "media/images/web/favicon/android-icon-36x36-3a6b936702438cb3bf36dc1e395ea3f9.png";